import HaltonHillsPerTicketReport from "../RegionsPayroll/HaltonHillsPerTicketReport";
import HaltonRegionPerTicketReport from "../RegionsPayroll/HaltonRegionPerTicketReport";
import WaterlooPerTicketReport from "../RegionsPayroll/WaterlooPerTicketReport";
import YorkPerTicketReport from "../RegionsPayroll/YorkPerTicketReport";

const PerTicketReportModal = ({ show, handleClose, data, user, region }) => {
  if (region?.value === "WATERLOO") {
    return (
      <WaterlooPerTicketReport
        show={show}
        handleClose={handleClose}
        data={data}
        user={user}
      />
    );
  }
  // for waterloo access data from data.waterloo
  // for york access data from data.york
  if (region?.value === "YORK") {
    return (
      <YorkPerTicketReport
        show={show}
        handleClose={handleClose}
        data={data}
        user={user}
      />
    );
  }
  if (region?.value === "HALTON HILLS") {
    return (
      <HaltonHillsPerTicketReport
        show={show}
        handleClose={handleClose}
        data={data}
        user={user}
      />
    );
  }
  if (region?.value === "HALTON REGION") {
    return (
      <HaltonRegionPerTicketReport
        show={show}
        handleClose={handleClose}
        data={data}
        user={user}
      />
    );
  }
  return <div>No region selected - Refresh the page</div>;
};

export default PerTicketReportModal;
